var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.99951V8.66618M8 11.3328H8.00667M14.4866 11.9995L9.15329 2.66617C9.037 2.46097 8.86836 2.29029 8.66457 2.17154C8.46078 2.0528 8.22915 1.99023 7.99329 1.99023C7.75743 1.99023 7.52579 2.0528 7.322 2.17154C7.11822 2.29029 6.94958 2.46097 6.83329 2.66617L1.49995 11.9995C1.38241 12.2031 1.32077 12.4341 1.32129 12.6692C1.32181 12.9042 1.38447 13.135 1.50292 13.338C1.62136 13.5411 1.79138 13.7092 1.99575 13.8254C2.20011 13.9415 2.43156 14.0016 2.66662 13.9995L13.3333 13.9995C13.5672 13.9993 13.797 13.9375 13.9995 13.8204C14.202 13.7032 14.3701 13.5349 14.487 13.3322C14.6038 13.1296 14.6653 12.8998 14.6653 12.6658C14.6652 12.4319 14.6036 12.2021 14.4866 11.9995Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleAlert);
export default __webpack_public_path__ + "static/media/TriangleAlert.3a4b35f9a1472b659513857bd804f929.svg";
export { ForwardRef as ReactComponent };